import { BrgButton, ButtonVariant, CommonInput, Colors, FlexBox, INPUT_TYPES } from "@brg/ui";
import { BaseSyntheticEvent, FC, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import setTextByLang from "shared/helpers/setTextByLang";

const Outer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    width: 720px;
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    // background-color: #343434;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);

    .ui-input_container {
        background-color: ${Colors.zelWhite10};
    }
    
    input {
        color: ${Colors.geoWhite100};
    }

    .close-modal-mobile {
        cursor: pointer;
    }

    .add-button {
        height: 48px;
        min-height: 48px;
        max-width: 244px;
        color: ${Colors.geoWhite100};
        border-color: ${Colors.geoWhite100};

        span {
            color: ${Colors.geoWhite100};
        }

        path {
            fill: ${Colors.geoWhite100};
        }
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    width: 100%;

    svg {
        cursor: pointer;
    }
`;

export const Column = styled(Row)`
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const ButtonWrapper = styled.div`

    * {
        color: ${Colors.galBlack100};
    }
`;

export const Title = styled.div`
    color: ${Colors.geoWhite100};
    font-size: 28px;
    line-height: 34px;
    white-space: pre-wrap;
    letter-spacing: -0.02em;
`;


export const InlineModal: FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { fields, variantOption: { optionIndex } } = useSelector(ApplicationEditorSelector);

    const options = useMemo(() => {
        return fields?.find(
          (field, i) => i === optionIndex)?.inlineVariants || [];
      }, [fields, optionIndex]);

    const isDisabled = useMemo(() => {
        return options?.length === 0
    }, [options]);

    const onAddNewOption = () => {
        const option = createDefaultLangObject('');
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: [...(newFields[optionIndex].inlineVariants || []), option]
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    const onCloseModal = () => {
        dispatch(ApplicationEditorActions.setVariantOption({
            visible: false,
            optionIndex: -1,
        }));
    }

    const onSaveChange = () => {
        dispatch(ApplicationEditorActions.setVariantOption({
            visible: false,
            optionIndex: -1,
        }));
    }

    const onChangeOption = (index: number, ev: BaseSyntheticEvent, lang: string) => {
        const newOptions = [...options];
        newOptions[index] = setTextByLang(options[index], lang, ev.target.value)
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: newOptions
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    const onDeleteOption = (index: number) => {
        const newOptions = [...options];
        newOptions.splice(index, 1);
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: newOptions
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    return (
        <Outer>
            <Container>
                <FlexBox gx={50} direction="row" justify="space-between" align="start">
                    <Title>{t('applicationEditor.sections.fields.configure_choice_fields')}</Title>
                    <CloseModalIconMob onClick={onCloseModal} />
                </FlexBox>
                <Column>
                    {options?.map((option, index) => (
                        <Row key={index}>
                            <CommonInput 
                                type={INPUT_TYPES.text}
                                onChange={(e: any, lang) => {
                                    onChangeOption(index, e, lang ?? 'ru')
                                }}
                                value={option}
                                placeholder="Введите текст"
                                label=""
                                required
                                useLangSwitcher
                                switcherPosition={'inside'}
                            />
                            <BasketIcon
                                fill={'#838382'}
                                onClick={() => onDeleteOption(index)}
                            />
                        </Row>
                    ))}
                </Column>
                <ProjectAddButton reverse onClick={onAddNewOption} text={t('teams.adminPage.fields.form_add_field')} />
                <ButtonWrapper>
                    <BrgButton disabled={isDisabled} variant={ButtonVariant.Filled} onClick={onSaveChange} customBg={'#fff'} fullWidth>{'Сохранить'}</BrgButton>
                </ButtonWrapper>
            </Container>
        </Outer>
    )
}import { BrgButton, ButtonVariant, CommonInput, Colors, FlexBox, INPUT_TYPES } from "@brg/ui";
import { BaseSyntheticEvent, FC, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import setTextByLang from "shared/helpers/setTextByLang";

const Outer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    width: 720px;
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    // background-color: #343434;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);

    .ui-input_container {
        background-color: ${Colors.zelWhite10};
    }
    
    input {
        color: ${Colors.geoWhite100};
    }

    .close-modal-mobile {
        cursor: pointer;
    }

    .add-button {
        height: 48px;
        min-height: 48px;
        max-width: 244px;
        color: ${Colors.geoWhite100};
        border-color: ${Colors.geoWhite100};

        span {
            color: ${Colors.geoWhite100};
        }

        path {
            fill: ${Colors.geoWhite100};
        }
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    width: 100%;

    svg {
        cursor: pointer;
    }
`;

export const Column = styled(Row)`
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const ButtonWrapper = styled.div`

    * {
        color: ${Colors.galBlack100};
    }
`;

export const Title = styled.div`
    color: ${Colors.geoWhite100};
    font-size: 28px;
    line-height: 34px;
    white-space: pre-wrap;
    letter-spacing: -0.02em;
`;


export const InlineModal: FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { fields, variantOption: { optionIndex } } = useSelector(ApplicationEditorSelector);

    const options = useMemo(() => {
        return fields?.find(
          (field, i) => i === optionIndex)?.inlineVariants || [];
      }, [fields, optionIndex]);

    const isDisabled = useMemo(() => {
        return options?.length === 0
    }, [options]);

    const onAddNewOption = () => {
        const option = createDefaultLangObject('');
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: [...(newFields[optionIndex].inlineVariants || []), option]
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    const onCloseModal = () => {
        dispatch(ApplicationEditorActions.setVariantOption({
            visible: false,
            optionIndex: -1,
        }));
    }

    const onSaveChange = () => {
        dispatch(ApplicationEditorActions.setVariantOption({
            visible: false,
            optionIndex: -1,
        }));
    }

    const onChangeOption = (index: number, ev: BaseSyntheticEvent, lang: string) => {
        const newOptions = [...options];
        newOptions[index] = setTextByLang(options[index], lang, ev.target.value)
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: newOptions
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    const onDeleteOption = (index: number) => {
        const newOptions = [...options];
        newOptions.splice(index, 1);
        const newFields = [...fields];
        newFields[optionIndex] = {
            ...newFields[optionIndex],
            inlineVariants: newOptions
        }
        dispatch(ApplicationEditorActions.setFields(newFields));
    }

    return (
        <Outer>
            <Container>
                <FlexBox gx={50} direction="row" justify="space-between" align="start">
                    <Title>{t('applicationEditor.sections.fields.configure_choice_fields')}</Title>
                    <CloseModalIconMob onClick={onCloseModal} />
                </FlexBox>
                <Column>
                    {options?.map((option, index) => (
                        <Row key={index}>
                            <CommonInput 
                                type={INPUT_TYPES.text}
                                onChange={(e: any, lang) => {
                                    onChangeOption(index, e, lang ?? 'ru')
                                }}
                                value={option}
                                placeholder="Введите текст"
                                label=""
                                required
                                useLangSwitcher
                                switcherPosition={'inside'}
                            />
                            <BasketIcon
                                fill={'#838382'}
                                onClick={() => onDeleteOption(index)}
                            />
                        </Row>
                    ))}
                </Column>
                <ProjectAddButton reverse onClick={onAddNewOption} text={t('teams.adminPage.fields.form_add_field')} />
                <ButtonWrapper>
                    <BrgButton disabled={isDisabled} variant={ButtonVariant.Filled} onClick={onSaveChange} customBg={'#fff'} fullWidth>{'Сохранить'}</BrgButton>
                </ButtonWrapper>
            </Container>
        </Outer>
    )
}